import { PageLayout } from '../components/PageLayout';
import { AIRuntimeSection } from '../components/sections/AIRuntimeSection';

export const Runtime = () => (
    <PageLayout>
        <AIRuntimeSection />
    </PageLayout>
);
